import { render, staticRenderFns } from "./ProcedureDocuments.vue?vue&type=template&id=094830a8"
import script from "./ProcedureDocuments.vue?vue&type=script&lang=js"
export * from "./ProcedureDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports